import { useContext } from 'react';

import Loadable from 'react-loadable';

import { HiddenLoader } from 'src/components/react-loadable';

import { DevToolsContext } from './context';

const LoadableDialog = Loadable({
  loading: HiddenLoader,
  loader: () => import('./dialog'),
});

export const LazyDevToolsDialog = () => {
  const { isEnabled } = useContext(DevToolsContext);
  return isEnabled ? <LoadableDialog /> : null;
};
